import React, { useState, useEffect } from 'react';
import IconCollection from '../../IconCollection/IconCollection';
import { TiArrowUpThick } from "react-icons/ti";
import { FiMinus, FiPlus } from "react-icons/fi";
import { useDispatch, useSelector } from 'react-redux';
import { resetShotClockReset1, resetShotClockReset2, setJumpBallClockNewSeconds, toggleShotClock, toggleTimeout, updateShotClockReset1, updateShotClockReset2, updateShotClockValue } from '../../redux/reducers/playersReducer';
import toast from 'react-hot-toast';
import { IoAdd, IoClose, IoRemove } from 'react-icons/io5';
import { startJumpBallClock, stopJumpBallClock } from '../../redux/actions/JumpBallClockService';
import { startTimer, stopTimer } from '../../redux/actions/timerService';

const ShotClock = ({ shotClockFullScreen, setShotClockFullScreen, handleShotClockFullScreen }) => {
  const [violation, setViolation] = useState(false);

  const { isRunning, General, minutes, seconds } = useSelector(
    (state) => state?.settingReducer
  );
  const { shotClockOptions } = General || {};
  const { shotClockCheck, shotClockViolation, foul: foulCheck, timeout: timeoutCheck, outOfBounds, goalWithinLast2Minutes, goalAnytimeDuringOvertime } = shotClockOptions || {};
  const {
    toPT,
    foul,
    foulActions,
    toActions,
    quarter,
    shotClock,
    shotClockValue,
    shotClockReset1,
    shotClockReset2,
    timeout
  } = useSelector((state) => state?.playersReducer);
  const dispatch = useDispatch();

  const foulCalledSetting = useSelector(
    (state) => state?.settingReducer?.General?.topTimerWhenFoulCalled
  );
  useEffect(() => {
    if (shotClockValue <= 0 && shotClockViolation) {
      setViolation(true);
    } else if (shotClockValue <= 0 && foulCheck && (foul || foulActions == "active")) {
      setViolation(true);
    } else if (shotClockValue <= 0 && timeoutCheck && timeout) {
      setViolation(true);
    } else if (shotClockValue <= 0 && outOfBounds && (toActions == "active" || toPT)) {
      setViolation(true);
    } else if (shotClockValue <= 0 && goalWithinLast2Minutes) {
      setViolation(true);
    } else if (shotClockValue <= 0 && goalAnytimeDuringOvertime) {
      setViolation(true);
    } else {
      setViolation(false);
    }
  }, [shotClock, shotClockValue])

  const handleShotClock = () => {
    if (isRunning || timeoutCheck) {
      startJumpBallClock(shotClockValue)
      if(timeoutCheck){
        startTimer(minutes, seconds)
        dispatch(toggleTimeout(true));
      }
    } else {
      toast.error("Please Turn On Main Timer");
    }
  }
  const handleShotClockStop = () => {
    stopJumpBallClock()
    if(timeoutCheck){
      stopTimer()
    }
  }
  const handleToggle = (type, action) => {
    if (type === "plus") {
      dispatch(action("plus"));
    } else if (type === "minus") {
      dispatch(action("minus"));
    }
  };



  const MinCount = ({ clockValue, handleToggle, handleReset }) => {
    return (
      <div
        className={`custom-drop-shadow flex-col lg:flex-row p-1.5 lg:p-2 rounded-md flex-1 flex items-center ${shotClockFullScreen ? "h-20 lg2:h-60 lg:h-80 justify-center gap-5 lg:gap-10" : "h-11 lg:h-14 gap-0  lg:gap-2"}`}

      >

        <div className={`flex  ${shotClockFullScreen ? "gap-5 lg:gap-10" : "lg:gap-2 gap-1"}`}>


        <button onClick={handleReset} className={`text-red-500  font-bebas ${shotClockFullScreen ? "lg:text-9xl lg2:text-5xl text-sm" : "text-[10px]  lg:text-sm"}`}>Reset</button>
        <div className={`text-red-500  font-bebas ${shotClockFullScreen ? "lg:text-9xl lg2:text-5xl text-xl" : "text-xs lg:text-xl"}`}>{clockValue}</div>
        </div>

        <div className={`flex flex-row lg:flex-col  ${shotClockFullScreen ? "lg2:gap-5 gap-1" : "gap-1"}`}>
          <button
            onClick={() => handleToggle("plus")}
            disabled={quarter === "Final" || quarter !== "n"}
            className={`cursor-pointer   flex justify-center items-center ${shotClockFullScreen ? "lg:w-32 lg:h-32 lg2:w-20 lg2:h-20  w-4 h-4 lg2:rounded-lg rounded-sm" : "w-4 h-4 rounded-sm"}`}
            style={{
              boxShadow: "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            <FiPlus className={`${shotClockFullScreen ? "text-2xl lg:text-[220px]" : "text-base"} text-[#7D7D7D]`} />
          </button>
          <button
            onClick={() => handleToggle("minus")}
            disabled={quarter === "Final" || quarter !== "n"}
            className={`cursor-pointer  rounded-sm flex justify-center items-center ${shotClockFullScreen ? "lg:w-32 lg:h-32 lg2:w-20 lg2:h-20  w-4 h-4 lg2:rounded-lg rounded-sm" : "w-4 h-4 rounded-sm"}`}
            style={{
              boxShadow: "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            <FiMinus className={`${shotClockFullScreen ? "text-2xl lg:text-[220px]" : "text-base"} text-[#7D7D7D]`} />
          </button>
        </div>
      </div>
    );
  };


  const handleResetShotClock = async (shotClockReset) => {
    try {
      stopJumpBallClock();
      dispatch(setJumpBallClockNewSeconds(shotClockReset));
      if(isRunning){
        startJumpBallClock(shotClockReset);
      }
    } catch (error) {
      console.error("Error resetting shot clock:", error);
    }
  }

  return (
    <div className='relative'>
      {
        shotClockFullScreen && (
          <div className={`fixed top-0 right-0 left-0 bottom-0 bg-[#f2f2f2] z-[40]`}></div>
        )
      }
      <div className={`
    bg-[#f2f2f2]
    ${shotClockFullScreen ? "max-w-[370px] z-50 lg2:max-w-[100vw] lg:max-w-[1512px] w-full px-6 mx-auto   p-0 lg:p-4 border-[0px] lg:border-[1px] border-[#CCCCCC] rounded-md flex flex-col fixed top-0 right-0 left-0 bottom-0 justify-center gap-5" : "max-w-[255px] w-full p-0 lg:p-4 border-[0px] lg:border-[1px] border-[#CCCCCC] rounded-md flex flex-col relative"}
    `}>

        {
          violation && (
            <p className='text-red-500 text-[6px] lg:text-xs font-montserrat absolute top-1 right-0 left-0 text-center'>Shot Clock Violation!</p>
          )
        }
        <button
          onClick={() => handleShotClockFullScreen()}
          className={`absolute -top-2 lg:top-0 right-0  ${shotClockFullScreen ? "text-red-500 rotate-0" : "rotate-45"}`}>
          {
            shotClockFullScreen ? <IoClose className='text-red-500 lg2:text-8xl text-base' /> : <TiArrowUpThick className='' />
          }
        </button>
        <div className='h-auto'>
          <div className="flex justify-between items-center gap-[6.5px] lg:gap-[6px] w-full">
            <div className="flex flex-col gap-1 lg:gap-4">
              <button
                disabled={isRunning || quarter === "Final"}
                onClick={() => dispatch(updateShotClockValue("plus"))}
                className={`${shotClockFullScreen ? "lg:w-56 lg:h-56 lg2:w-28 lg2:h-28  w-6 h-6 rounded lg2:rounded-2xl flex justify-center items-center" : "cursor-pointer w-5 h-5 rounded flex justify-center items-center"}`}
                style={{
                  boxShadow: "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
                }}
              >
                {/* <IconCollection name="plus-icon-16" /> */}
                <IoAdd className={`${shotClockFullScreen ? "text-base lg2:text-8xl lg:text-[220px]" : "text-base"} text-[#7D7D7D]`} />
              </button>
              <button
                disabled={isRunning || quarter === "Final"}
                onClick={() => dispatch(updateShotClockValue("minus"))}
                className={`${shotClockFullScreen ? "lg:w-56 lg:h-56 lg2:w-28 lg2:h-28  w-6 h-6 rounded lg2:rounded-2xl flex justify-center items-center" : "cursor-pointer w-5 h-5 rounded flex justify-center items-center"}`}
                style={{
                  boxShadow: "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
                }}
              >
                <IoRemove className={`${shotClockFullScreen ? "text-base lg2:text-8xl lg:text-[220px]" : "text-base"} text-[#7D7D7D]`} />
              </button>
            </div>
            <div className={`font-bebas text-[#1A1A1A]  flex items-center gap-2
            ${shotClockFullScreen ? "text-4xl lg2:text-[300px]" : "text-2xl lg:text-[64px]"}
          `}>
              {shotClockValue}
            </div>
            {
              shotClock ?
                <button
                  disabled={quarter == "Final" || shotClockValue == 0}
                  onClick={() => handleShotClockStop()}
                  className={`  flex justify-center items-center cursor-pointer ${shotClockFullScreen ? "w-10 h-[28px] lg:w-64 lg:h-64 lg2:w-28 lg2:h-28 rounded-sm lg2:rounded-2xl" : "w-10 lg:w-10 h-[28px] lg:h-10 rounded-sm"}`}
                  style={{
                    boxShadow:
                      "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
                  }}
                >
                  <IconCollection
                    customClass={` ${shotClockFullScreen ? "lg:max-w-44 lg2:max-w-[100px] max-w-5 w-full lg:h-44 lg2:h-[100px] h-5" : "lg:max-w-5 max-w-[10px] w-full lg:h-5 h-[10px]"}`}
                    name={"pause-icon"}

                  />

                </button> : <button
                  disabled={quarter == "Final" || shotClockValue == 0}
                  onClick={() => handleShotClock()}
                  className={`  flex justify-center items-center cursor-pointer ${shotClockFullScreen ? "w-10 h-[28px] lg:w-64 lg:h-64 lg2:w-28 lg2:h-28 rounded-sm lg2:rounded-2xl" : "w-8 lg:w-10 h-4 lg:h-10 rounded-sm"}`}
                  style={{
                    boxShadow:
                      "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
                  }}
                >
                  <IconCollection
                    customClass={` ${shotClockFullScreen ? "lg:max-w-44 lg2:max-w-[100px] max-w-5 w-full lg:h-44 lg2:h-[100px] h-5" : "lg:max-w-5 max-w-[10px] w-full lg:h-5 h-[10px]"}`}
                    name={"play-icon"}
                  />

                </button>
            }

          </div>
        </div>

        <div className={`flex flex-row justify-between items-center w-full pt-1 lg:pt-3 ${shotClockFullScreen ? "lg:gap-10 gap-5" : "gap-[6.5px] lg:gap-[6px] "}`}>
          <MinCount
            clockValue={shotClockReset1}
            handleToggle={(type) => handleToggle(type, updateShotClockReset1)}
            handleReset={() => handleResetShotClock(shotClockReset1)}
          />
          <MinCount
            clockValue={shotClockReset2}
            handleToggle={(type) => handleToggle(type, updateShotClockReset2)}
            handleReset={() => handleResetShotClock(shotClockReset2)}
          />
        </div>
      </div>
    </div>
  );
};

export default ShotClock;